import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AdvertorialV1 } from './pages/AdvertorialV1';
import { AdvertorialV2 } from './pages/AdvertorialV2';
import { AdvertorialV3 } from './pages/AdvertorialV3';
import { AdvertorialV4 } from './pages/AdvertorialV4';
import { AdvertorialV5 } from './pages/AdvertorialV5';
import './index.css';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        {/* Default route shows V1 */}
        <Route path="/" element={<AdvertorialV1 data-id="element-3" />} data-id="element-2" />
        <Route path="/v1" element={<AdvertorialV1 data-id="element-5" />} data-id="element-4" />
        <Route path="/v2" element={<AdvertorialV2 data-id="element-7" />} data-id="element-6" />
        <Route path="/v3" element={<AdvertorialV3 data-id="element-9" />} data-id="element-8" />
        <Route path="/v4" element={<AdvertorialV4 data-id="element-11" />} data-id="element-10" />
        <Route path="/v5" element={<AdvertorialV5 data-id="element-13" />} data-id="element-12" />
        {/* Catch-all redirect to home */}
        <Route path="*" element={<Navigate to="/" replace data-id="element-15" />} data-id="element-14" />
      </Routes>
    </BrowserRouter>;
}